<div class="profile-flex-container" *ngIf="product_platform_list?.length >= 1">
    <div class="profile-flex-item" *ngFor="let product of product_platform_list; let ind = index"
        [id]="'profile-flex-item-'+ind" (click)="selectProduct(product)" [id]="product.business_unit_code"
        [ngClass]="product.business_unit_code == selected_product_code ? 'selected-item' : '' ">
        {{product.business_unit}}
    </div>
    <div class="region-market" *ngIf="selected_product_code">
        <p>Default Region & Market</p>
        <form [formGroup]="regionMarketForm">
            <div class="flex-holder">
                <div class="flex-div">
                    <mat-form-field appearance="outline" [hideRequiredMarker]="true" floatLabel="always">
                        <mat-label>Region</mat-label>
                        <mat-select (openedChange)="regionOpenedChange($event)" placeholder="Select"
                            formControlName="regionSelectFormControl">
                            <div class="select-container">
                                <mat-optgroup>
                                    <div style="width:100%;" class="search-input">
                                        <input #searchRegion autocomplete="off" placeholder="Search" aria-label="Search"
                                            matInput formControlName="regionSearchTextboxControl">
                                        <button [disableRipple]="true" *ngIf="searchRegion.value" matSuffix
                                            mat-icon-button aria-label="Clear" (click)="regionClearSearch($event)">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                    </div>
                                </mat-optgroup>
                                <mat-optgroup *ngIf="(regionFilteredOptions | async).length == 0">
                                    <div>No results found!</div>
                                </mat-optgroup>
                                <mat-option (onSelectionChange)="regionSelectionChange($event,option)"
                                    *ngFor="let option of regionFilteredOptions | async" [value]="option">
                                    {{option}}
                                </mat-option>
                            </div>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="flex-div">
                    <mat-form-field appearance="outline" [hideRequiredMarker]="true" floatLabel="always">
                        <mat-label>Market</mat-label>
                        <mat-select (openedChange)="marketOpenedChange($event)" placeholder="Select"
                            formControlName="marketSelectFormControl" multiple panelClass="my-target-panel">
                            <mat-select-trigger>
                                {{getMarketNameByCode(regionMarketForm.get('marketSelectFormControl')?.value) ?
                                getMarketNameByCode(regionMarketForm.get('marketSelectFormControl')?.value[0]) : ''}}
                                <span *ngIf="regionMarketForm.get('marketSelectFormControl')?.value?.length > 1"
                                    class="additional-selection">
                                    (+{{getMarketNameByCode(regionMarketForm.get('marketSelectFormControl')?.value).length
                                    - 1}}
                                    {{getMarketNameByCode(regionMarketForm.get('marketSelectFormControl')?.value)?.length
                                    === 2 ?
                                    'market'
                                    :
                                    'markets'}})
                                </span>
                            </mat-select-trigger>
                            <div class="select-container">
                                <mat-optgroup>
                                    <div style="width:100%;" class="search-input">
                                        <input #searchMarket autocomplete="off" placeholder="Search" aria-label="Search"
                                            matInput formControlName="marketSearchTextboxControl">
                                        <button [disableRipple]="true" *ngIf="searchMarket.value" matSuffix
                                            mat-icon-button aria-label="Clear" (click)="marketClearSearch($event)">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                    </div>
                                </mat-optgroup>
                                <mat-optgroup *ngIf="(marketFilteredOptions | async)?.length == 0">
                                    <div>No results found!</div>
                                </mat-optgroup>
                                <mat-option (onSelectionChange)="marketSelectionChange($event)"
                                    *ngFor="let option of marketFilteredOptions | async"
                                    [value]="option.primary_market.code">
                                    {{option.primary_market.name}}
                                </mat-option>
                            </div>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
    <div class="submit-btn-holder">
        <p class="validation-msg" *ngIf="!hasSelectedPlatform">Please select at least one platform group to update.</p>
        <button class="submit-btn" (click)="setBUMarketAndRegion(true)" [disabled]="!hasSelectedPlatform">Update</button>
    </div>
</div>